<template>
  <div
    class="applicant"
    v-loading="loading"
    :element-loading-text="loadingText"
    element-loading-custom-class="csv-loading"
  >
    <div class="message message-error mb-x3" v-if="contractStatus === 3">
      <div>現在、サービスのご利用が終了しているため、一部の機能に制限がかかっています。</div>
      <div>ご利用を再開したい場合は、弊社担当にご連絡いただくか、右下のチャットからお問い合わせください。</div>
    </div>
    <applicant-random-dialog ref="applicantRandomDialog"></applicant-random-dialog>
    <applicant-reset-dialog ref="applicantResetDialog"></applicant-reset-dialog>
    <applicant-import-dialog ref="applicantImportDialog"></applicant-import-dialog>
    <DialogTikTokFollowCheck ref="dialogTikTokFollowCheck"></DialogTikTokFollowCheck>
    <div class="applicant-head mb-x2">
      <div layout="row" layout-align="space-between-start">
        <applicant-filter></applicant-filter>
        <div class="campaign-info" v-if="campaignPrize && campaignPrize.id">
          <div layout layout-align="space-between-start">
            <span class="mr-x3">応募者数: {{ formatNumber(campaignPrize.applicantsCount) }}</span
            ><span>候補者数: {{ formatNumber(campaignPrize.candidateCount) }}</span>
          </div>
          <div layout layout-align="space-between-start">
            <span class="mr-x3"
              >当選者数: {{ formatNumber(campaignPrize.winnerCount) }}(残り{{
                formatNumber(campaignPrize.maxWinnerCount - campaignPrize.winnerCount)
              }})</span
            ><span>回答者数: {{ formatNumber(campaignPrize.responderCount) }}</span>
          </div>
        </div>
      </div>
      <transition name="advance-filter-transition">
        <applicant-advance-filter class="mt-x2" v-if="showAdvanceFilter" />
      </transition>
    </div>
    <div class="card" v-if="firstLoaded" v-loading="isLoading">
      <div class="mb-x2" layout layout-align="space-between-center">
        <div layout>
          <el-button
            type="default"
            @click="openApplicantRandomDialog"
            :disabled="!campaign.account || !campaign.account.id || !applicants.length || contractStatus === 3"
            ><i class="mdi mdi-dice-multiple"></i>ランダム抽選</el-button
          >
          <el-button
            type="default"
            @click="openFollowCheckDialog"
            :disabled="!campaign.account || !campaign.account.id || !applicants.length || contractStatus === 3"
            ><i class="mdi mdi-check-circle"></i>フォローチェック</el-button
          >
          <el-dropdown class="ml-x1" trigger="click" @command="openDialog">
            <el-button class="dropdown-button" type="default" :disabled="!applicants.length || contractStatus === 3"
              ><i class="mdi mdi-playlist-play mr-x1"></i>一括操作<i
                class="mdi mdi-chevron-down dropdown-arrow ml-x3"
              ></i
            ></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in actionDialogs"
                :key="item.value"
                :command="item.value"
                :divided="item.divided"
                >{{ item.label }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <csv-download
          v-if="!error"
          :download="downloadCsv"
          :disabled="!applicants.length || contractStatus === 3"
        ></csv-download>
      </div>
      <div class="mb-x1" layout layout-align="space-between-center">
        <span class="mr-x3 caption"> 総件数 : {{ formatNumber(options.total) }}件 </span>
        <div class="view-type-button">
          <el-button-group class="ml-x1">
            <el-button
              :disabled="!applicants.length || contractStatus === 3"
              :type="viewType === 'list' ? 'primary' : 'default'"
              @click="changeViewType('list')"
              ><i class="mdi mdi-view-list" />一覧</el-button
            >
            <el-button
              :disabled="!applicants.length || contractStatus === 3"
              :type="viewType === 'grid' ? 'primary' : 'default'"
              @click="changeViewType('grid')"
              ><i class="mdi mdi-view-module" />グリッド</el-button
            >
          </el-button-group>
        </div>
      </div>
      <div v-if="error">
        <div class="message message-error">
          データ取得に失敗しました。恐れ入りますが、時間を置いて再度お試しください。
        </div>
      </div>
      <div v-else>
        <div v-if="campaign.lastProcessedDatetime === null && !applicants.length">
          <div class="message message-info message-center">
            <b>条件に該当する応募者のデータがありません。</b
            ><br /><br />初回の応募収集は、キャンペーン開催から30分後です。<br />収集が開始されるまで、しばらくお待ちください。
            <div class="mt-x2"><img class="wait-image" src="@/client/assets/images/time.png" /></div>
          </div>
        </div>
        <div class="message message-info" v-else-if="!applicants.length">
          条件に該当する応募者のデータがありません。
        </div>
        <div v-else>
          <applicant-table
            :applicants="applicants"
            :options="options"
            :campaignAccountId="campaignAccountId"
            :campaignId="campaign.id"
            :campaignStartDatetime="campaign.startDatetime"
            @paging="onPaging"
            @sorting="onSorting"
            @change_flag="changeFlag"
            @change_ng="changeNgAccount"
            v-if="viewType === 'list'"
          ></applicant-table>
          <applicant-grid
            :applicants="applicants"
            :options="options"
            @paging="onPaging"
            @change_flag="changeFlag"
            @change_ng="changeNgAccount"
            v-if="viewType === 'grid'"
            snsType="tiktok"
          ></applicant-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/client/assets/scss/variables.scss' as *;

.applicant {
  .csv-loading {
    .el-loading-spinner {
      top: 40vh;

      .el-loading-text {
        white-space: pre-line;
      }
    }
  }
}

.view-type-button {
  height: $spacing-unit * 4;
}

.message-center {
  text-align: center;
}

.wait-image {
  max-width: $spacing-unit * 13;
}
</style>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.campaign-info {
  position: relative;
  margin-top: $spacing-unit;

  .last-processe-datetime {
    position: absolute;
    top: $spacing-unit * 3;
  }
}

.el-dropdown {
  .dropdown-button {
    width: $spacing-unit * 20;

    .dropdown-arrow {
      color: $disabled-color;
    }
  }
}

.advance-filter-transition-enter-active,
.advance-filter-transition-leave-active {
  transition: all 0.2s ease;
}

.advance-filter-transition-enter,
.advance-filter-transition-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import CsvDownload from '@/client/components/_atoms/csv_download'
import DialogTikTokFollowCheck from '@/client/components/_organisms/DialogTikTokFollowCheck.vue'
import api from '@/client/core/api'
import util from '@/client/core/util'
import ApplicantAdvanceFilter from '@/client/features/tiktok_applicant/applicant_advance_filter'
import ApplicantFilter from '@/client/features/tiktok_applicant/applicant_filter'
import ApplicantGrid from '@/client/features/tiktok_applicant/applicant_grid'
import ApplicantImportDialog from '@/client/features/tiktok_applicant/applicant_import_dialog'
import ApplicantRandomDialog from '@/client/features/tiktok_applicant/applicant_random_dialog'
import ApplicantResetDialog from '@/client/features/tiktok_applicant/applicant_reset_dialog'
import ApplicantTable from '@/client/features/tiktok_applicant/applicant_table'
import { formatDatetime, formatNumber } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'
import { useNavbarStore } from '@/client/store/useNavbarStore'
import { useSystemStore } from '@/client/store/useSystemStore'
import { useTikTokApplicantStore } from '@/client/store/useTikTokApplicantStore'
import { TApplicant } from '@/typings/api/tiktok_applicants.type'

export default defineComponent({
  components: {
    CsvDownload,
    ApplicantFilter,
    ApplicantAdvanceFilter,
    ApplicantTable,
    ApplicantGrid,
    DialogTikTokFollowCheck,
    ApplicantImportDialog,
    ApplicantRandomDialog,
    ApplicantResetDialog
  },
  data() {
    return {
      loading: false,
      loadingText: '',
      is_submit: false,
      actionDialogs: [
        {
          label: 'フォローインポート',
          value: 'import_follower'
        },
        {
          label: '候補者インポート',
          value: 'import_candidate'
        },
        {
          label: '当選者インポート',
          value: 'import_winner'
        },
        {
          label: '回答者インポート',
          value: 'import_responder'
        },
        {
          label: '当選連絡インポート',
          value: 'import_winner_contact'
        },
        {
          label: '候補者解除',
          value: 'reset_candidate',
          divided: true
        },
        {
          label: '当選者解除',
          value: 'reset_winner'
        },
        {
          label: '回答者解除',
          value: 'reset_responder'
        },
        {
          label: 'フォロー解除',
          value: 'reset_follower'
        }
      ],
      viewType: 'list'
    }
  },
  async created() {
    this.setParams({ campaignId: this.$route.params.campaignId, prizeId: this.$route.params.prizeId })
    // キャンペーンデータを取得
    await Promise.allSettled([this.fetchCampaign(), this.fetchCampaignPrize(), this.fetchApplicants()])

    if (this.campaign && this.campaign.id && this.currentGroupId !== this.campaign.groupId) {
      this.setCurrentGroup(this.campaign.groupId)
    }

    this.setBreadcrumb([
      {
        name: 'キャンペーン一覧',
        link: '/campaigns'
      },
      {
        name: this.campaign.title,
        link: `/tiktok_campaigns/${this.campaign.id}/prizes`,
        iconName: this.campaign.account ? this.campaign.account.name : '削除されたアカウント',
        iconUrl: this.campaign.account.pictureUrl,
        iconType: this.campaign.snsType,
        isIcon: true
      },
      {
        name: this.campaignPrize.name,
        link: null
      }
    ])
  },
  computed: {
    ...mapState(useSystemStore, {
      currentGroupId: state => state.currentGroup.id,
      contractStatus: state => state.currentGroup.contractStatus
    }),
    ...mapState(useTikTokApplicantStore, {
      params: state => state.params,
      applicants: state => state.applicants,
      campaign: state => {
        if (state.campaign) {
          return state.campaign
        }
        return {}
      },
      campaignAccountId: state => {
        if (state.campaign && state.campaign.account) {
          return +state.campaign.account.id
        }

        return 0
      },
      campaignPrize: state => {
        if (state.campaignPrize) {
          return state.campaignPrize
        }
        return {}
      },
      options: state => {
        return {
          total: state.total,
          pagingNo: state.params.pagingNo,
          limitCount: state.params.limitCount,
          sortBy: state.params.sortBy
        }
      },
      firstLoaded: state => state.firstLoaded,
      error: state => state.error,
      showAdvanceFilter: state => state.showAdvanceFilter,
      isLoading: state => state.isLoading
    })
  },
  methods: {
    formatNumber,

    ...mapActions(useSystemStore, ['setCurrentGroup']),
    ...mapActions(useNavbarStore, ['setBreadcrumb']),
    ...mapActions(useTikTokApplicantStore, [
      'reset',
      'fetchApplicants',
      'fetchCampaignPrize',
      'fetchCampaign',
      'setParams',
      'updateWinner',
      'updateResponder',
      'updateWinnerContact',
      'updateFollower',
      'updateCandidate',
      'updateNgAccount'
    ]),

    /**
     * Open dialog
     * @param {string} value
     */
    openDialog(value: string) {
      TrackingService.sendEvent('select:応募一覧（TT）|一括操作')

      if (value.indexOf('reset') !== -1) {
        const type = value.replace('reset_', '')
        this.$refs.applicantResetDialog.open(type)
      } else {
        const type = value.replace('import_', '')
        this.$refs.applicantImportDialog.open(type)
      }
    },

    /**
     * ページを変更イベント
     * @param {number} page ページ
     */
    onPaging(payload: { pagingNo: number; limitCount: number }) {
      this.setParams(payload)
      util.scrollToTop()
    },

    /**
     * ソートを変更イベント
     * @param {string} sortBy ソート
     */
    onSorting(value: string) {
      if (this.params.sortBy === value) {
        return
      }

      this.setParams({ sortBy: value })
    },

    /**
     * 対象応募者のフラグの変更
     */
    async changeFlag(payload: { applicantId: number; type: string; value: number }) {
      const { applicantId, type, value } = payload

      let text = ''
      let result: any
      this.is_submit = true

      switch (type) {
        case 'is_follower':
          result = await this.updateFollower({
            applicantId,
            isFollowing: value
          })
          text = 'フォロー'
          break
        case 'is_candidate':
          result = await this.updateCandidate({
            applicantId,
            isCandidate: value
          })
          text = '候補者'
          break
        case 'is_winner':
          result = await this.updateWinner({
            applicantId,
            isWinner: value,
            wasWinner: 1
          })
          text = '当選者'
          break
        case 'is_responder':
          result = await this.updateResponder({
            applicantId,
            isResponder: value
          })
          text = '回答者'
          break
        case 'is_winner_contact':
          text = '当選連絡'
          result = await this.updateWinnerContact({
            applicantId,
            isWinnerContact: value
          })
          break
      }

      if (!result) {
        this.is_submit = false
        return
      }

      if (result.error && result.error.type === 'MAX_WINNER_COUNT_OVER') {
        this.showError('残り当選数に空きがありません。')
        this.is_submit = false
        return
      }

      if (!result.data) {
        this.showError(`${text}の保存に失敗しました`)
        this.is_submit = false
        return
      }

      this.is_submit = false
    },

    /**
     * NGアカウント追加/解除処理
     * @param {{screenName: string, isNg: boolean, ngApplicantId: number | null}} payload
     */
    async changeNgAccount(payload: { screenName: string; isNg: boolean; ngApplicantId: number | null }) {
      const result = await this.updateNgAccount(payload)
      if (!result || !result.data) {
        this.$notify({
          title: 'NGアカウントの更新に失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
      }
    },

    /**
     * グリッドの切替
     * @param {string} viewType
     */
    changeViewType(viewType: string) {
      TrackingService.sendEvent(`click:応募一覧（TT）|${viewType === 'list' ? '一覧' : 'グリッド'}`)

      this.viewType = viewType
    },

    /**
     * エラーを表示
     * @params {string} title タイトル
     * @params {string} message
     */
    showError(title: string, message = '') {
      this.$notify({
        title: title,
        message: message,
        customClass: 'danger',
        duration: 5000
      })
    },

    /**
     * ランダム抽選ダイアログを開く
     */
    openApplicantRandomDialog() {
      TrackingService.sendEvent('click:応募一覧（TT）|ランダム抽選')

      this.$refs.applicantRandomDialog.open()
    },

    /**
     * フォローチェックダイアログを開く
     */
    openFollowCheckDialog() {
      TrackingService.sendEvent('click:応募一覧（TT）|フォローチェック')

      this.$refs.dialogTikTokFollowCheck.open()
    },

    /**
     * 当選者解除ダイアログを開く
     */
    openApplicantResetWinnerDialog() {
      this.$refs.applicantResetWinnerDialog.open()
    },

    /**
     * 当選者解除ダイアログを開く
     */
    openApplicantResetResponderDialog() {
      this.$refs.applicantResetResponderDialog.open()
    },

    /**
     * CSVダウンロード
     */
    async downloadCsv() {
      TrackingService.sendEvent('click:応募一覧（TT）|CSVダウンロード')

      const applicants: TApplicant[] = await this.getApplicantsForCsv()
      if (!applicants.length) {
        return { error: 'ERROR_LOADING' }
      }

      const filename = `campaign_applicants_${moment().format('YYYY_MM_DD')}`

      // フィルター条件がある場合CSVファイルの一番上に追加する
      const filterCondition = []
      let filterConditionIsFollowing = ''
      let filterConditionIsWinner = ''
      let filterConditionIsResponder = ''
      let filterConditionIsWinnerContact = ''
      const params = this.params

      // フォローでフィルター条件がある場合は、フィルター条件に追加する
      switch (params.isFollowing) {
        case 1:
          filterConditionIsFollowing = 'フォローあり'
          break
        case 0:
          filterConditionIsFollowing = 'フォローなし'
          break
      }

      if (filterConditionIsFollowing) {
        filterCondition.push([filterConditionIsFollowing])
      }

      // 当選者でフィルター条件がある場合は、フィルター条件に追加する
      switch (params.isWinner) {
        case 1:
          filterConditionIsWinner = '当選フラグあり'
          break
        case 0:
          filterConditionIsWinner = '当選フラグなし'
          break
      }

      if (filterConditionIsWinner) {
        filterCondition.push([filterConditionIsWinner])
      }

      // 回答者でフィルター条件がある場合は、フィルター条件に追加する
      switch (params.isResponder) {
        case 1:
          filterConditionIsResponder = '回答フラグあり'
          break
        case 0:
          filterConditionIsResponder = '回答フラグなし'
          break
      }

      if (filterConditionIsResponder) {
        filterCondition.push([filterConditionIsResponder])
      }

      // 当選連絡でフィルター条件がある場合は、フィルター条件に追加する
      switch (params.isWinnerContact) {
        case 1:
          filterConditionIsWinnerContact = '当選連絡フラグあり'
          break
        case 0:
          filterConditionIsWinnerContact = '当選連絡フラグなし'
          break
      }

      if (filterConditionIsWinnerContact) {
        filterCondition.push([filterConditionIsWinnerContact])
      }

      // 累計参加数フィルター条件がある場合、フィルター条件に追加する
      const filterConditionTotalCampaignEntryCount = this.createFilterConditionText(
        params.totalCampaignEntryCount[0],
        params.totalCampaignEntryCount[1],
        '累計参加数'
      )

      if (filterConditionTotalCampaignEntryCount) {
        filterCondition.push([filterConditionTotalCampaignEntryCount])
      }

      // 累計当選数フィルター条件がある場合、フィルター条件に追加する
      const filterConditionTotalCampaignWinningCount = this.createFilterConditionText(
        params.totalCampaignWinningCount[0],
        params.totalCampaignWinningCount[1],
        '累計当選数'
      )

      if (filterConditionTotalCampaignWinningCount) {
        filterCondition.push([filterConditionTotalCampaignWinningCount])
      }

      // アカウント名検索でフィルター条件がある場合は、フィルター条件に追加する
      if (params.accountName) {
        filterCondition.push(['アカウント名' + '[' + params.accountName + ']'])
      }

      const csvData = []

      // フィルター条件がある場合は、一番最初の行にフィルター条件を追加する
      if (filterCondition.length > 0) {
        csvData.push(['フィルター条件:', filterCondition.join('/')])
      }

      csvData.push([
        'No',
        'ユーザー名',
        'アカウントURL',
        'アカウント画像',
        '応募日時',
        '投稿内容',
        '投稿URL',
        '応募数',
        '累計参加数',
        '累計当選数',
        'NGアカウント',
        '候補者',
        '当選者',
        '回答者',
        '当選連絡'
      ])

      // CSVデータを格納
      applicants.forEach((applicant, index) => {
        csvData.push([
          index + 1,
          applicant.screenName,
          'https://www.tiktok.com/@' + applicant.screenName,
          applicant.pictureUrl,
          formatDatetime(applicant.post.publishDatetime),
          applicant.post.message ? applicant.post.message.replace(/(\r\n|\n|\r)/gm, '') : '',
          applicant.post.shareUrl,
          applicant.postsCount,
          applicant.totalCampaignEntryCount,
          applicant.totalCampaignWinningCount,
          applicant.isNg,
          applicant.isCandidate,
          applicant.isWinner,
          applicant.isResponder,
          applicant.isWinnerContact
        ])
      })
      return {
        filename,
        data: csvData
      }
    },

    /**
     * CSVファイルに追加する累計参加数、累計当選数のフィルター条件のテキスト
     * @param {number} overNumber 以上の数
     * @param {number} lessNumber 未満の数
     * @param {string} conditionText フィルター条件のテキスト
     */
    createFilterConditionText(overNumber: any, lessNumber: any, conditionText: string) {
      // 累計参加数、累計当選数のフィルター条件が未入力の場合はリターン
      if ((overNumber === undefined && lessNumber === undefined) || (overNumber === '' && lessNumber === '')) {
        return
      }
      return (
        conditionText +
        String(overNumber).replace(/(\d)(?=(\d{3})+\b)/g, '$1,') +
        '~' +
        String(lessNumber).replace(/(\d)(?=(\d{3})+\b)/g, '$1,')
      )
    },

    /**
     * CSV用応募者一覧を取得
     */
    async getApplicantsForCsv() {
      this.loading = true
      const { total } = this.options
      this.getTextLoading(0, total)

      const params = Object.assign({}, this.params, {
        pagingNo: 1,
        limitCount: 1000,
        forCsv: 1
      })

      let totalResults = []
      // 1000件ごとに取得する
      for (let count = 0; count < total; count += 1000) {
        const result = await api.get('/tiktok_applicants', { params })

        const surplus = (total - count) / 1000

        if (surplus < 1) {
          this.getTextLoading(total, total)
        } else {
          this.getTextLoading(count + 1000, total)
        }

        if (!result.data) {
          this.loading = false
          return []
        }

        totalResults = totalResults.concat(result.data.applicants)
        params.pagingNo = params.pagingNo + 1
      }

      this.loading = false
      return totalResults
    },

    /**
     * CSVダウンロードの時、進捗を表示する
     * @params {number} acquiredNumber
     * @params {number} totalNumber
     */
    getTextLoading(acquiredNumber: number, totalNumber: number) {
      this.loadingText = `CSVファイルの作成中です。しばらくお待ちください。\n ${acquiredNumber}件 / ${totalNumber}件`
    }
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    // 応募者ストアをリセット
    this.reset()
    next()
  }
})
</script>
